
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 85.145 85.145"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M25.19 20.593c0-.294-.93-2.757-.92-3.048.011-.341.964-.677.989-1.01.636-8.39 5.172-14.199 11.355-16.382v7.091c0 4.072 2.667 7.373 5.957 7.373 3.291 0 5.957-3.3 5.957-7.373V.347c7.823 3.168 10.734 12.06 11.571 16.461.062.322.731.235.769.508.121.935-1.404 3.277-1.404 3.277-3.555 1.751-6.688 3.843-10.361 4.248l-13.518-.064c-5.787-.987-10.395-4.184-10.395-4.184zm24.186 6.672l-.144.016-14.068-.101c-4.105-.701-7.628-2.392-9.633-3.516 1.135 8.409 8.322 14.898 17.043 14.898 8.868 0 16.167-6.71 17.106-15.33-.458.235-.92.469-1.367.706-2.758 1.456-5.608 2.96-8.937 3.327zm22.542 34.512v17.869h-.121l-1.15.584c-.582.293-9.973 4.914-26.172 4.914-8.295 0-18.373-1.211-29.971-4.834l-1.232-.386-.045-.278V61.777c0-12.154 9.889-22.043 22.041-22.043h14.607c12.156 0 22.043 9.889 22.043 22.043zM46.664 76.045l-1.889-26.889a.27.27 0 00-.271-.25h-3.647a.268.268 0 00-.27.25l-1.758 26.891a.281.281 0 00.042.162l3.514 5.542a.266.266 0 00.223.124h.007a.264.264 0 00.223-.12l3.783-5.537a.27.27 0 00.043-.173zm.926-31.559c0-.623-.504-1.125-1.125-1.125h-7.543c-.623 0-1.127.502-1.127 1.125l3.141 6.492h3.613l3.041-6.492zm-5.018-30.569c-3.013 0-5.464-2.98-5.464-6.643V0h10.927v7.275c0 3.662-2.45 6.642-5.463 6.642zM38.108 1v6.275c0 3.111 2.002 5.643 4.464 5.643 2.461 0 4.463-2.531 4.463-5.643V1h-8.927z"}})])
          )
        }
      }
    